import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiLink = {
  defaultProps: {
    underline: "always"
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      return {
        textDecorationColor: "currentcolor",
        display: "inline-flex",
        alignItems: "center",
        color: theme.palette.primary.main,
        ".MuiSvgIcon-root": {
          margin: theme.spacing(0, 0.5)
        },
        "&:visited": {
          color: theme.palette.primary.main
        },
        "&.Mui-focusVisible, &:focus-visible": {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: "2px",
          borderRadius: capitalDesignTokens.foundations.units.unitQuarter
        },
        // Disabled state styling - handle both Mui-disabled class and aria-disabled attribute
        '&.Mui-disabled, &[aria-disabled="true"]': {
          color: theme.palette.text.secondary,
          opacity: 0.6,
          pointerEvents: "none",
          cursor: "default",
          textDecoration: ownerState.underline === "always" ? "underline" : "none"
        }
      };
    }
  },
  variants: [
    {
      props: {
        variant: "standalone-small"
      },
      style: ({ theme }) => ({
        textDecoration: "none",
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
        "&:hover": {
          textDecoration: "underline"
        },
        "&::after": {
          display: "inline-block",
          marginLeft: theme.spacing(0.5)
        }
      })
    },
    {
      props: {
        variant: "standalone"
      },
      style: ({ theme }) => ({
        textDecoration: "none",
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
        "&:hover": {
          textDecoration: "underline"
        },
        "&::after": {
          display: "inline-block",
          marginLeft: theme.spacing(0.5)
        }
      })
    },
    {
      props: {
        variant: "standalone-large"
      },
      style: ({ theme }) => ({
        textDecoration: "none",
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
        "&:hover": {
          textDecoration: "underline"
        },
        "&::after": {
          display: "inline-block",
          marginLeft: theme.spacing(0.5)
        }
      })
    }
  ]
};
export {
  MuiLink
};
//# sourceMappingURL=MuiLink.js.map
